import type { ThemeData } from '../models';
import { defaultTheme } from './defaultTheme';

export const toothWipesTheme: ThemeData = {
  ...defaultTheme,
  homeHero: {
    default: {
      media: {
        mobile: {
          src: 'https://cdn.shopify.com/videos/c/o/v/8bd3f8d9f60c449f954b757644a2fc70.mp4',
          height: 272,
          width: 414,
        },
        desktop: {
          src: 'https://cdn.shopify.com/videos/c/o/v/402c059fb5e94fdd9b099e96f8b2d802.mp4',
          height: 640,
          width: 760,
        },
        alt: 'Exfoliating tooth wipes',
        to: '/products/exfoliating-tooth-wipes/',
      },
      content: {
        title: 'Wipe away stains with Tooth Wipes',
        description: `Engineered with hydroxyapatite and xylitol to lift the day's build-up off your teeth.`,
        button: {
          text: 'Shop now',
          to: '/products/exfoliating-tooth-wipes/',
          width: 'full-width',
          size: 'md',
        },
      },
    },
  },
  marqueeData: {
    default: {
      text: `NEW Tooth Wipes, available NOW`,
      to: `/products/exfoliating-tooth-wipes`,
    },
    ca: {
      text: `New Tooth Armour Toothpaste Serum. Order NOW`,
      to: `/products/tooth-armour`,
    },
  },
  navImageBlocks: {
    default: {
      imageBlocks: [
        {
          title: 'iD Stain Whitening Mouthwash',
          link: '/products/id-stain-mouthwash/',
          details: {
            src: 'https://cdn.shopify.com/s/files/1/2502/5300/files/Nav_-_Starter_Bundle_V2-_M_cdbf4791-c1b1-4542-adf2-ceb3fbcdae9c.png?v=1767658631',
            alt: 'iD Stain Whitening Mouthwash',
            height: 240,
            width: 366,
          },
        },
        {
          title: 'Exfoliating Tooth Wipes',
          link: '/products/exfoliating-tooth-wipes',
          details: {
            src: 'https://cdn.shopify.com/s/files/1/0916/4078/files/Nav_-_Tooth_Wipes.png?v=1779944897',
            alt: 'Tooth Wipes',
            height: 240,
            width: 366,
          },
        },
      ],
    },
    ca: {
      imageBlocks: [
        {
          title: 'Shop Electric Toothbrush',
          link: '/products/electric-toothbrush/',
          details: {
            src: 'https://cdn.shopify.com/s/files/1/0916/4078/files/Nav_-_Electric_Toothbrush.jpg?v=1706071329',
            alt: 'Electric Toothbrush in Pink, Purple and Green',
            height: 240,
            width: 366,
          },
        },
        {
          title: 'Tooth Armour',
          link: '/products/tooth-armour',
          details: {
            src: 'https://cdn.shopify.com/s/files/1/2502/5300/files/Nav_-_Tooth_Armour.png?v=1774928763',
            alt: 'Tooth Armour',
            height: 240,
            width: 366,
          },
        },
      ],
    },
  },
};
